export default __webpack_public_path__ + "static/media/ingbank.40376734.png";